import { XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import codesfile from "../assets/AFL_CHAMPION_STATS.csv";
import { convertSecondsToMinutesSeconds } from "../utils/Utils";

function Chain({ chain, onSelectEvent, onChainCancel }) {
  const [codes, setCodes] = useState([]);
  const doInit = () => {
    if (codes.length > 0) {
      return;
    }
    fetch(codesfile)
      .then((r) => r.text())
      .then((text) => {
        const lines = text.split(/\r?\n/);
        const headers = lines[0].split(",");
        const codes = [];
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim();
          const tokens = line.split(",");
          const obj = {};
          for (let j = 0; j < tokens.length; j++) {
            obj[headers[j].trim()] = tokens[j].trim();
          }
          if (!codes[tokens[1]]) {
            codes[tokens[1]] = obj;
          }
        }
        // console.log("codes:", codes);
        setCodes(codes);
      });
  };

  const getDescription = (e) => {
    if (!codes) {
      return "";
    }
    const code = codes[e["STATISTIC_CODE"]];
    return code ? code.DESC_SHORT : "";
  };

  useEffect(() => {
    doInit();
    console.log(chain);
  }, []);

  return (
    <>
      <div className="flex-col">
        <div className="flex justify-between p-2">
          <div className="">Chain {chain?.chainId}</div>
          <XMarkIcon
            className="h-6 w-6 cursor-pointer"
            onClick={() => {
              onChainCancel();
            }}
          />
        </div>
        <div className="flex-col h-[24vh] overflow-auto mt-1 shadow-lg  bg-base-200/80">
          <ul className="flex flex-col gap-1">
            {chain &&
              chain.events.map((e, idx) => (
                <li
                  key={idx}
                  className={
                    idx % 2 !== 0
                      ? "px-1 py-0.5 cursor-pointer"
                      : "px-1 py-0.5 bg-base-300/50 cursor-pointer"
                  }
                  onClick={() => {
                    onSelectEvent(e);
                  }}
                >
                  <div className="flex-col">
                    <div className="flex justify-between">
                      <div className="font-bold">{e["FULLNAME"]}</div>
                    </div>
                    <div className="text-xs">{getDescription(e)}</div>
                    <div className="flex justify-between">
                      <div className="text-left">
                        {convertSecondsToMinutesSeconds(e["PERIOD_SECS"])}
                      </div>
                      <div>
                        {e["distance"] && parseFloat(e["distance"]).toFixed(2)}m
                      </div>
                      {/* <div>{e["STATISTIC_CODE"]}</div> */}
                    </div>
                  </div>
                </li>
              ))}
          </ul>
          {/* <table className="table-generic w-full">
            <thead>
              <tr>
                <th className="text-left">Player</th>
                <th className="text-left">Dist</th>
                <th className="text-left">Time</th>
                <th className="text-left">Code</th>
                <th className="text-left">Desc</th>
              </tr>
            </thead>
            <tbody>
              {chain && chain.events.map((e, idx) => (
                <tr
                  key={idx}
                  className={
                    idx % 2 !== 0
                      ? "px-1 py-0.5 cursor-pointer"
                      : "px-1 py-0.5 bg-base-300/50 cursor-pointer"
                  }
                  onClick={() => {
                    onSelectEvent(e);
                  }}
                >
                  <td>{e["FULLNAME"]}</td>
                  <td>{e["distance"] && parseFloat(e["distance"]).toFixed(2)}</td>
                  <td className="text-left">
                    {convertSecondsToMinutesSeconds(e["PERIOD_SECS"])}
                  </td>
                  <td>{e["STATISTIC_CODE"]}</td>
                  <td>{getDescription(e)}</td>
                </tr>
              ))}
            </tbody>
          </table> */}
        </div>
      </div>
    </>
  );
}

export default Chain;
